import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { apiUrl } from "../../config.js";
import StaffSearch from "../StaffSearch-Component/Staff-Search";
import ViewProfileControl from "./ViewProfileControl";

const formatDateToTime = (dateStr) => {
    return new Date(dateStr).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit"
    });
};

export default function EventControlPersonRow({
    person,
    selectedRotaShiftIds,
    handleCheckBox,
    handleBookOnOff,
    fetchOccurrencesByRsid,
    handleProfileShiftUpdate,
    locationOptions,
    roleOptions,
    jwt,
    setStaffData
}) {
    const startDate = person.startTime ? new Date(person.startTime) : null;
    const finishDate = person.finishTime ? new Date(person.finishTime) : null;
    const bookOnDate = person.bookedOnDateTime ? new Date(person.bookedOnDateTime) : null;
    const bookOffDate = person.bookedOffDateTime ? new Date(person.bookedOffDateTime) : null;
    const startDisplay = person.startTime ? formatDateToTime(person.startTime) : "";
    const finishDisplay = person.finishTime ? formatDateToTime(person.finishTime) : "";
    const bookOnDisplay = person.bookedOnDateTime ? formatDateToTime(person.bookedOnDateTime) : "";
    const bookOffDisplay = person.bookedOffDateTime ? formatDateToTime(person.bookedOffDateTime) : "";
    const [showModalstaffsearch, setShowModalstaffsearch] = useState(false);
    const [staffSearchCtx, setStaffSearchCtx] = useState({
        pageName: "",
        shiftId: 0,
        rowId: 0,
        csv: 0
    });
    const handleCloseModal = async (selectedvalues) => {
        const firstRow = selectedvalues?.[0];

        if (!firstRow) {
            setShowModalstaffsearch(false);
            return;
        }

        try {
            const payload = {
                shiftsIn: staffSearchCtx.csv.toString(),
                staffId: Number(firstRow.id)
            };

            const response = await fetch(`${apiUrl}/Events/AllocateStaffToShifts`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `bearer ${jwt}`
                },
                body: JSON.stringify(payload)
            });

            const result = await response.json();

            if (!response.ok || result?.message) {
                window.alert(result?.message || "Failed to allocate staff");
                return;
            }

            setStaffData((prev) =>
                prev.map((data) =>
                    data.rotaShiftId === staffSearchCtx.csv
                        ? {
                            ...data,
                            firstName: firstRow.firstName,
                            lastName: firstRow.lastName,
                            staffID: firstRow.id
                        }
                        : data
                )
            );
        } catch (error) {
            console.error("Allocate staff error:", error);
            window.alert("Something went wrong while allocating staff.");
        } finally {
            setShowModalstaffsearch(false);
        }
    };

    const fullName = [person.firstName, person.lastName].filter(Boolean).join(" ");
    const hasName = fullName.length > 0;

    const getBookOnColor = () => {
        if (!startDate || !bookOnDate) return "#666";
        if (isNaN(startDate.getTime()) || isNaN(bookOnDate.getTime())) return "#666";
        return bookOnDate <= startDate ? "green" : "red";
    };

    const getBookOffColor = () => {
        if (!finishDate || !bookOffDate) return "#666";
        if (isNaN(finishDate.getTime()) || isNaN(bookOffDate.getTime())) return "#666";
        return bookOffDate < finishDate ? "red" : "green";
    };

    return (
        <>
            <tr>
                <td style={{ textAlign: "center", minWidth: "50px" }}>
                    <Form.Check
                        disabled={!hasName}
                        name={person.staffID}
                        checked={selectedRotaShiftIds.includes(person.rotaShiftId)}
                        onChange={() => handleCheckBox(person.rotaShiftId)}
                    />
                </td>
                <td style={{ minWidth: "200px" }}>{person.siteName}</td>
                <td style={{ minWidth: "50px" }}>
                    {startDisplay}
                    {bookOnDisplay && (
                        <span style={{ color: getBookOnColor() }}>
                            {" "}
                            ({bookOnDisplay})
                        </span>
                    )}
                </td>
                <td style={{ minWidth: "50px" }}>
                    {finishDisplay}
                    {bookOffDisplay && (
                        <span style={{ color: getBookOffColor() }}>
                            {" "}
                            ({bookOffDisplay})
                        </span>
                    )}
                </td>
                <td>{hasName ? fullName : <strong>Un allocated</strong>}</td>
                <td>{person.roleName}</td>
                <td>{person.eventLocation}</td>
                <td className="position-relative" style={{ minWidth: "30px" }}>
                    {hasName && (
                        <ViewProfileControl
                            staffId={person.staffID}
                            start={person.startTime}
                            finish={person.finishTime}
                            FirstName={person.firstName}
                            LastName={person.lastName}
                            role={person.roleName}
                            roleid={person.roleId}
                            location={person.eventLocation}
                            rotaShiftId={person.rotaShiftId}
                            MobileNo={person.mobileNo}
                            staffPhoto={person.staffPhoto}
                            bookon={person.bookedOnDateTime}
                            bookoff={person.bookedOffDateTime}
                            locationOptions={locationOptions}
                            roleOptions={roleOptions}
                            fetchOccurrencesByRsid={fetchOccurrencesByRsid}
                            onShiftUpdated={handleProfileShiftUpdate}
                            onBookOnOff={handleBookOnOff}
                            renderTrigger={(handleOpen) => (
                                <button
                                    type="button"
                                    className="rota-actions-toggle rounded-button"
                                    onClick={handleOpen}
                                    aria-haspopup="dialog"
                                    title="Actions"
                                >
                                    <span className="kebab-dot" />
                                    <span className="kebab-dot" />
                                    <span className="kebab-dot" />
                                </button>
                            )}
                        />
                    )}
                    {!hasName && (
                        <button
                            type="button"
                            className="rota-actions-toggle rounded-button"
                            disabled
                            title="Actions unavailable"
                        >
                            <span className="kebab-dot" />
                            <span className="kebab-dot" />
                            <span className="kebab-dot" />
                        </button>
                    )}
                </td>
            </tr>

            <StaffSearch
                showModal={showModalstaffsearch}
                handleClose={handleCloseModal}
                pageName={staffSearchCtx.pageName}
                shiftId={staffSearchCtx.shiftId}
                rowId={staffSearchCtx.rowId}
                csv={staffSearchCtx.csv}
            />
        </>
    );
}
